import { render, staticRenderFns } from "./userLabel.vue?vue&type=template&id=12834de3&"
import script from "./userLabel.vue?vue&type=script&lang=js&"
export * from "./userLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports